import React, { useState, useEffect } from "react";
import {
  Space,
  Row,
  Col,
  InputNumber,
  Form,
  Input,
  Button,
  message,
  Switch,
} from "antd";
import DatePicker from "@general/datePicker";
import UploadFile from "@general/UploadFile";
import { gql, useMutation } from "@apollo/client";
import DeleteExpenditure from "@general/deleteSideExpenditure";
const UPDATEEXPENDITURE = gql`
  mutation updateExpenditure($updateInput: UpdateExpenditureInput!, $id: ID!) {
    updateExpenditure(updateInput: $updateInput, id: $id)
  }
`;

function SideExpendituresForm({ formData, expenditureId, onDoUpdateData }) {
  const [form] = Form.useForm();
  const [error, setError] = useState(null);
  const [editable, setEditable] = useState(false);

  const [runUpdateExpenditure, updateExpenditure] = useMutation(
    UPDATEEXPENDITURE,
    {
      onCompleted() {
        message.success("هزینه بروزرسانی شد.");
        onDoUpdateData();
      },
      onError(err) {
        console.log("خطا: " + err.message);
        message.error("مشکلی پیش آمده! هزینه بروزرسانی نشد.");
      },
    }
  );

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData]);

  const doUpdateExpenditure = (updateInput) => {
    runUpdateExpenditure({
      variables: {
        id: expenditureId,
        updateInput: {
          ...updateInput,
          amount: parseInt(updateInput.amount),
        },
      },
    });
  };

  return (
    <>
      <Row>
        <Space align>
          <p>ویرایش: </p>
          <Switch onChange={() => setEditable(!editable)} />
        </Space>
      </Row>{" "}
      <Form
        layout="vertical"
        onFinish={doUpdateExpenditure}
        form={form}
        disabled={!editable}
      >
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <Form.Item
              name="amount"
              id="amount"
              label="مبلغ هزینه (ریال)"
              decimalSeparator
              rules={[
                {
                  required: true,
                  message: "لطفا هزینه را وارد کنید!",
                },
                {
                  pattern: /^[0-9]*$/,
                  message: "لطفا هزینه را به طور صحیح وارد کنید",
                },
              ]}
            >
              <InputNumber
                formatter={(value) =>
                  value?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "") || ""}
                className="form-input"
                placeholder={"مبلغ هزینه"}
                style={{ textAlign: "left", width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              label="بابت (توضیحات)"
              name="description"
              rules={[{ required: true, message: "این فیلد ضروری است" }]}
            >
              <Input.TextArea rows={2} placeholder="توضیحات" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              label="تاریخ وقوع"
              name="occurrenceAt"
              rules={[{ required: true, message: "این فیلد ضروری است" }]}
            >
              <DatePicker
                showToday={false}
                format="YYYY/MM/DD"
                className="rtl"
                placeholder="تاریخ وقوع"
              />
            </Form.Item>
            <Form.Item
              name="documentImg"
              label="تصویر سند"
              validateStatus={error && "error"}
            >
              <UploadFile square />
            </Form.Item>
          </Col>
        </Row>
        <Space style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={updateExpenditure.loading && true}
          >
            ثبت
          </Button>
          <DeleteExpenditure
            id={expenditureId}
            onDeleteExpenditure={onDoUpdateData}
          >
             <Button danger type="text">
              حذف هزینه
            </Button>
          </DeleteExpenditure>
        </Space>
      </Form>
    </>
  );
}

export default SideExpendituresForm;
